export const shadows = {
  highDown: '0px 9px 12px rgba(30, 33, 36, 0.14)',
  highUp: '0px -9px 12px rgba(0, 0, 0, 0.14)',
  medium: '0px 4px 8px rgba(30, 33, 36, 0.08)',
  small: '0px 2px 4px rgba(37, 35, 33, 0.14)',
  card: '0px 1px 3px rgba(0, 0, 0, 0.2)',
};
